import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { acceptOperation, deferOperation, notifyShownOperation } from './surveyInvite-operations';

export interface SurveyInviteState {
  show: boolean;
  loading: boolean;
  error: string | null;
  acknowledged: boolean;
  resolved: 'accepted' | 'postponed' | null;
}

const initialState: SurveyInviteState = {
  show: false,
  loading: false,
  error: null,
  acknowledged: false,
  resolved: null,
};

const surveyInviteSlice = createSlice({
  name: 'surveyInvite',
  initialState,
  reducers: {
    setShow(state, { payload }: { payload: boolean }) {
      state.show = payload;
    },
    hardHide(state) {
      state.show = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (b) => {
    b.addCase(notifyShownOperation.fulfilled, (s) => {
      s.loading = false;
      s.error = null;
      s.acknowledged = true;
    });
    b.addCase(deferOperation.fulfilled, (s) => {
      s.loading = false;
      s.error = null;
      s.resolved = 'postponed';
      s.show = false;
      // Запомним в sessionStorage чтобы в этой сессии не дёргать снова
      sessionStorage.setItem('surveyInviteResolved', 'postponed');
    });
    b.addCase(acceptOperation.fulfilled, (s) => {
      s.loading = false;
      s.error = null;
      s.resolved = 'accepted';
      s.show = false;
      sessionStorage.setItem('surveyInviteResolved', 'accepted');
      sessionStorage.setItem('allowRenewSurvey', '1');
    });

    b.addMatcher(
      isAnyOf(notifyShownOperation.pending, deferOperation.pending, acceptOperation.pending),
      (s) => {
        s.loading = true;
        s.error = null;
      }
    );
    b.addMatcher(
      isAnyOf(notifyShownOperation.rejected, deferOperation.rejected, acceptOperation.rejected),
      (s, { payload, error }) => {
        s.loading = false;
        s.error = (payload as string) || error.message || null;
      }
    );
  },
});

export const { setShow, hardHide, clearError } = surveyInviteSlice.actions;
export default surveyInviteSlice.reducer;
